 // 月票manager
 let MonthTicketManager = xClass("MonthTicketManager")

 //  let MonthTicketIcon = require("activity/MonthTicket/MonthTicketIcon")
 MonthTicketConst = {
     equity: "equity", //权益卡
     res: "res", //资源卡
     pack: "pack", //打包卡
     try: "try", //试用卡
 }
 const productIdEnum = {
     "equity": 76,
     "res": 77,
     "pack": 78,
     "try": 79,
 }
 let instance = null
 MonthTicketManager.getInstance = function () {
     let self = this
     if (!instance) {
         instance = MonthTicketManager.create()
     }
     return instance
 }
 MonthTicketManager.prototype.init = function () {
     if (!this.getConfig()) {
         this.setConfig(MetaManager.getInstance().monthTicketConfig)
     }
     this.resetInfo()
     if(this.getCube() == "a") {
        this.updateInfo(UserManager.getInstance().monthCardInfo) //从登录信息中更新
     }
 }
 MonthTicketManager.prototype.ctor = function () {
     let self = this
     this.init()
 }
 //数据处理---------------------------------------------------------------------------------------------------------------
 const info_default = {
     openFlag: 0, //是否开启月卡功能，1为开启，0为不开启
     privilegeEndTs: 0, //权益卡结束时间，0代表未购买
     resourceEndTs: 0, //资源卡结束时间，0代表未购买
     resourceRewards: null, //资源卡每日奖励，null代表已领取
     trialBuyTs: 0, //试用版购买时间，0代表未购买
 }
 MonthTicketManager.prototype.resetInfo = function () {
     let info = {}
     for (const key in info_default) {
         info[key] = info_default[key]
     }

     this.info = info

 }
 // 更新数据
 MonthTicketManager.prototype.updateInfo = function (evt) {
     if (!evt) return
     for (const key in this.info) {
         if (evt[key]) {
             this.info[key] = evt[key]
         } else {
             this.info[key] = info_default[key]
         }
     }
     UserManager.getInstance().updateMonthCardInfo(evt)
     cc.log("MonthTicket updateInfo ", this.info)
 }

 MonthTicketManager.prototype.updateIcon = function (cb) {
     let self = this
     pcall(function () {
        self.dcUserStatus()
        const Event = require("hecore/EventDispatcher").Event;
        //  let MonthTicketIcon = require("activity/MonthTicket/MonthTicketIcon")
        //  let homeScene = require("clover/scene/HomeScene").getInstance()
        //  let icon = homeScene.btnLayer.monthTicketIconBtn

         if (!self.isOpen()) {
            GlobalEventDispatcher.getInstance().dispatchEvent(Event.new(kGlobalEvents.kWelfareCenterAction,
                {
                    id: WelfareCenterId.monthTicket,
                    type: "del",
                }))
            //  icon && icon.removeFromParent()
             cb && cb()
             return
         }
        GlobalEventDispatcher.getInstance().dispatchEvent(Event.new(kGlobalEvents.kWelfareCenterAction,
            {
                id: WelfareCenterId.monthTicket,
                redDot: self.isShowRedPoint(),
            }))
        cb && cb();
        return;
         if (!icon) {
             MonthTicketIcon.show().then(() => {
                 cb && cb()
             }).catch((evt) => {
                 cb && cb()
             })
         } else {
             icon.updateIcon()
             cb && cb()
         }
     })
 }

 MonthTicketManager.prototype.setConfig = function (config) {
     let self = this
     self.config = config
 }
 MonthTicketManager.prototype.getConfig = function () {
     return this.config
 }
 MonthTicketManager.prototype.isOpen = function () {
    return false
     if (!UserManager.getInstance().isHaveEquityMonthTicket() && !UserManager.getInstance().isHaveResourceMonthTicket()
     && !MetaManager.isSupportCash()){
        cc.log("MonthTicket isOpen 没有权益 且禁止支付的情况下 不显示")
        return false
     }
     return this.info.openFlag
 }
 //  是否能买体验卡
 MonthTicketManager.prototype.isCanExperienceTicket = function () {
     return this.info.trialBuyTs == 0
 }
 MonthTicketManager.prototype.getEquityEndTs = function () {
     return this.info.privilegeEndTs
 }
 MonthTicketManager.prototype.getResourceEndTs = function () {
     return this.info.resourceEndTs
 }
 MonthTicketManager.prototype.getRemainderDay = function (endTs) {
     let timeCur = Localhost.time()
     if (timeCur > endTs) return 0
     let num = getDayDiffByTime(timeCur, endTs)
     return num
 }
 //  equity 权益  res 资源 月卡
 MonthTicketManager.prototype.isReachLimit = function (type) {
     if (type == MonthTicketConst.equity) {
         let limit = this.config.privilege_card_hold_limit
         let num = this.getRemainderDay(this.getEquityEndTs())
         return num + 30 > limit ? "762463" : false
     } else if (type == MonthTicketConst.res) {
         let num = this.getRemainderDay(this.getResourceEndTs())
         let limit = this.config.resource_card_hold_limit
         return num + 30 > limit ? "762464" : false
     } else {
        let addNum = type == MonthTicketConst.try ? 7 : 30
        
         let num1 = this.getRemainderDay(this.getEquityEndTs())
         let limit1 = this.config.privilege_card_hold_limit
         let num2 = this.getRemainderDay(this.getResourceEndTs())
         let limit2 = this.config.resource_card_hold_limit
         if (num1+addNum > limit1) return "762463"
         if (num2+addNum > limit2) return "762464"
     }
     return false

 }

 MonthTicketManager.prototype.getProductId = function (type) {
     return productIdEnum[type]
 }
 MonthTicketManager.prototype.getGoodsIds = function (keys) {
     let arr = []
     for (let i = 0; i < keys.length; i++) {
         let key = keys[i]
         let goodsId = MetaManager.getProductMetaByID(productIdEnum[key]).goodsId
         arr.push(goodsId)

     }
     return arr
     //  return MetaManager.getProductMetaByID(LightningRushProductId).goodsId

 }
 MonthTicketManager.prototype.getGoodMeta = function (type) {
     let productId = this.getProductId(type)
     let product = MetaManager.getProductMetaByID(productId)
     let good = MetaManager.getInstance().getGoodsMeta(product.goodsId)
     return good
 }

 // 获取每日领取奖励
 MonthTicketManager.prototype.getDailyRewards = function () {
     cc.log("MonthTicket  getRewards ", this.config)
     let resource_card_daily_rewards = this.config.resource_card_daily_rewards
     let arr = resource_card_daily_rewards.split(",")
     let rewards = []
     for (let i = 0; i < arr.length; i++) {
         let conf = arr[i]
         let arr1 = conf.split(":")
         rewards.push({
             itemId: Number(arr1[0]),
             num: arr1[1]
         })
     }
     // let goodsMeta = MetaManager.getInstance().getGoodsMeta(8001)
     // cc.log("MonthTicket  getRewards goodsMeta ",goodsMeta)

     cc.log("MonthTicket  getRewards rewards ", rewards)
     return rewards
 }
 MonthTicketManager.prototype.buy = function (type, onSuccessCb, onFailCb, onCancelCb, scene, dc4Cash) {
     let self = this
     if(self.isClose()) {
        Toast.make(getText("month.ticket.close.tip1"));
        onFailCb()
        return
     }

     if (!MetaManager.isSupportCash()) {
         Toast.make("暂未开放")
         onFailCb()
         return
     }
     let errCode = self.isReachLimit(type)
     if (errCode) {
         onFailCb()
         Toast.make(getText("error.tip." + errCode))
         return
     }
     if (type == MonthTicketConst.try){
         self.dcMonthTicketNormal("trial_double_check_click", self.getDCSession(), {
            click_type: "buy"
        })
     }
     let productId = self.getProductId(type)

     function onSuccess() {
         let product = MetaManager.getProductMetaByID(productId)
         let good = MetaManager.getInstance().getGoodsMeta(product.goodsId)
         let successCb = () => {
             self.dcUserStatus()
             onSuccessCb(true)
         }
        //
        let checkTicketAd = () => {
            if(type != MonthTicketConst.res && self.adPanel) {
                self.adPanel.onBuySuc && self.adPanel.onBuySuc();
            }
        }
         ActivityGetRewardsPanel.show({
             type: 2,
             // extraHint: extraNode,
             //  add_model: ModuleName.MONTH_TICK, // test 为获取道具的category
             rewardList: good.items,
             tobagAni: true,
             title: `normal`,
             closeCb: () => {
                 // 处理数据 
                 self.infoHttp().then(() => {
                     successCb()
                     checkTicketAd()
                 }).catch(() => {
                     Toast.make(quickGetErrorText("", getText("error.tip.load_res_error")))
                     onFailCb()
                     checkTicketAd()
                 })
             }
         })

     }

     function onFail(evt) {
         showRMBPayFailMsg(evt, () => {});
         onFailCb()

     }

     function onCancel() {
         onCancelCb()
         Toast.make(getText(`取消支付`));
     }
     //productid是序号
     UserProduct.getInstance().buyProduct(productId, onSuccess, onFail, onCancel, scene, dc4Cash);

 }
 // 网络协议
 MonthTicketManager.prototype.infoHttp = function (openPanel) {
     let self = this
     if(self.getCube() == "b") {
        return new Promise((resolve, reject) => {
            resolve()
        })
     }

     return new Promise((resolve, reject) => {
         function success(evt) {
             if (evt && evt.data) {
                 cc.log(" MonthTicket infoHttp ", evt.data)
                 self.updateInfo(evt.data)
                 self.updateIcon()
             }
             resolve() 
         }
         let http = MonthCardInfoHttp.new()
         http.addEventListener(Events.kComplete, success)
         http.addEventListener(Events.kError, (evt) => {
             reject(evt)
         })
         http.addEventListener(Events.kCancel, () => {
             reject(0)
         })
         http.load()
     })
 }
 MonthTicketManager.prototype.fetchRewardHttp = function (type) {
     //  return new Promise((resolve, reject) => {
     //      resolve()
     //  })
     let self = this
     return new Promise((resolve, reject) => {
         function success(evt) {
             if (evt && evt.data) {
                 cc.log("MonthTicket fetchRewardHttp ", evt.data)
                 let rewards = evt.data.rewards
                 if (rewards) {
                     ActivityGetRewardsPanel.show({
                         type: 2,
                         // extraHint: extraNode,
                         add_model: "profit_daily", // test 为获取道具的category
                         rewardList: rewards,
                         tobagAni: true,
                         title: `normal`,
                         closeCb: () => {

                         }
                     })
                     self.info.resourceRewards = null
                     self.updateIcon()
                 }
             }
             resolve()
         }
         let http = MonthCardFetchRewardHttp.new()
         http.addEventListener(Events.kComplete, success)
         http.addEventListener(Events.kError, (evt) => {
             Toast.make(quickGetErrorText(evt.data, getText("error.tip.load_res_error")))
             reject(evt)
         })
         http.addEventListener(Events.kCancel, () => {
             Toast.make(quickGetErrorText(evt.data, getText("error.tip.load_res_error")))
             reject(0)
         })
         http.load(type)
     })
     // 
 }

 MonthTicketManager.prototype.getResourceRewards = function () {
     return this.info.resourceRewards
 }
 MonthTicketManager.prototype.isShowRedPoint = function () {
     if (this.getOpenLastTime() <= 0) {
         return true
     }
     if (this.getResourceRewards()) {
         return true
     }
     return false

 }

 MonthTicketManager.prototype.getCube = function() {
   return UserManager.getInstance().getGroupByKey("month_card_test");
 }

 //是否关闭月卡
 MonthTicketManager.prototype.isClose = function() {
    return true;
 }
 // --------------------------显示界面
 MonthTicketManager.prototype.showMainPanel = function (closeCb,successCb,entry) {
     let MonthTicketPanel = require("./MonthTicketPanel")
     MonthTicketPanel.show(closeCb,successCb,entry)
 }
 MonthTicketManager.prototype.showTryPanel = function (closeCb,entry) {
     let MonthTicketTryPanel = require("./MonthTicketTryPanel")
     MonthTicketTryPanel.show(closeCb,entry)
 }

 MonthTicketManager.prototype.showAdPanel = function(successCb,failCb,adPos) {
    let MonthTicketAdPanel = require("./MonthTicketAdPanel");
    MonthTicketAdPanel.show(successCb, failCb,adPos);
 }

 const MONTH_TICKET_OPEN_KEY = "month_ticket_open_key_"

 MonthTicketManager.prototype.getOpenLastTime = function () {
     let time = cc.UserDefault.getInstance().getIntegerForKey(MONTH_TICKET_OPEN_KEY + UserManager.getInstance().uid, 0)
     return time
 }
 MonthTicketManager.prototype.setOpenLastTime = function () {
     let time = Localhost.time()
     cc.UserDefault.getInstance().setIntegerForKey(MONTH_TICKET_OPEN_KEY + UserManager.getInstance().uid, time)
     this.updateIcon()
 }
 // dc------------------------------------------------------------------------------------------------------------------------------
 MonthTicketManager.prototype.createDCSession = function (uid) {
     let uid_new = uid || UserManager.getInstance().uid
     this.dcSession = `${uid_new}_${Localhost.timeInSec()}`
     return this.dcSession
 }

 MonthTicketManager.prototype.getDCSession = function () {
     return this.dcSession || this.createDCSession()
 }

 MonthTicketManager.prototype.dcPageShow = function (entry) {
     let param = {}
     param.session = this.createDCSession()
     param.type = entry ? entry: "main";
     param.num = this.getRemainderDay(this.getEquityEndTs())
     param.total_num = this.getRemainderDay(this.getResourceEndTs())
     if (this.isCanExperienceTicket()) {
         if (this.isReachLimit("res") || this.isReachLimit(MonthTicketConst.equity)) {
             param.patition = 2
         } else {
             param.patition = 1
         }
     } else {
         param.patition = 0
     }

     DCAssist.dc4User101(ModuleName.MONTH_TICK, "page_show", param)
 }
 MonthTicketManager.prototype.dcTryPageShow = function () {
     let param = {}
     param.session = this.getDCSession()
     if (this.isReachLimit("res") || this.isReachLimit(MonthTicketConst.equity)) {
         param.patition = 2
     } else {
         param.patition = 1
     }
     DCAssist.dc4User101(ModuleName.MONTH_TICK, "trial_double_check_show", param)
 }
 MonthTicketManager.prototype.dcMonthTicketNormal = function (sub_category, session, data = {}) {
     let param = {}
     for (const key in data) {
         param[key] = data[key]
     }
     param.session = session ? session : `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`
     DCAssist.dc4User101(ModuleName.MONTH_TICK, sub_category, param)
 }

 MonthTicketManager.prototype.dcUserStatus = function () {
     let param = {}
     param.session = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`
     let equity_num = this.getRemainderDay(this.getEquityEndTs())
     let res_num = this.getRemainderDay(this.getResourceEndTs())
     let dcFunc = (type, num) => {
         param.type = type
         param.num = num || 0
         DCAssist.dc4User101(ModuleName.MONTH_TICK, "user_status", param)
     }
     if (equity_num <= 0 && res_num <= 0) {
         dcFunc("none")
     } else {
         if (equity_num > 0) {
             dcFunc("privilege", equity_num)
         }
         if (res_num > 0) {
             dcFunc("profit", res_num)
         }
     }
 }
 module.exports = MonthTicketManager